import { useState, useEffect } from 'react';
import { Carousel, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { relatedData } from '../constants/TempData';

const RelatedProducts = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [groupedData, setGroupedData] = useState({});
    const [activeKey, setActiveKey] = useState('0');
        const navigate = useNavigate();
    const [shop, setShop] = useState([
        {
            title: "",
            salePrice: "",
            originalPrice: "",
            image: [],
            code: "",
            category:""
        }
    ]);

    const fetchBlog = async () => {
        const res = relatedData;

        setShop([...res])
    }
    const handleViewDetail = (item) => {
        navigate(`/shop/${item.code}`, { state: { shop: item } });
    }
    useEffect(() => {
        fetchBlog();
    }, [])

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false); // 🔥 stop loading after 1min
        }, 2000);

        return () => clearTimeout(timer); // Cleanup if unmount
    }, []);

    return (
        <div className="esi-std-container pb-5">
            <div className="esi-content-title">
                {t("Related Products")}
                <div className="esi-secondary-line"></div>
            </div>

            {/* Ant Design Carousel */}
            <Carousel
                autoplay
                dots={false}
                slidesToShow={4}
                draggable
                responsive={[
                    { breakpoint: 640, settings: { slidesToShow: 1 } },
                    { breakpoint: 1024, settings: { slidesToShow: 4 } },
                ]}
            >
                {loading ? (
                    // Display Skeleton Cards when loading
                    [...Array(4)].map((_, index) => (
                        <div key={index} className="pr-2 pl-2 pt-4 pb-4" style={{ paddingRight: "1rem" }}>
                            <div className="bg-white rounded-lg overflow-hidden transition-transform hover:scale-105" style={{ cursor: "pointer" }}>
                                {/* Skeleton for Image */}
                                <div className="relative group">
                                    <Skeleton.Image className='card-image-scarf' active style={{ width: '80%', height: '240px' }} />
                                </div>

                                {/* Skeleton for Title and Description */}
                                <div className='text-start w-full text-white md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[90%] mt-3 pb-3 line-clamp-2 m-auto d-flex'>
                                    <Skeleton.Input active block />
                                    <Skeleton.Input active block />
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    // Display Real Data Cards when loading is complete
                    relatedData.map((so, index) => (
                        <div key={index} className="pr-2 pl-2 pt-4 pb-4" style={{ paddingRight: "1rem" }} onClick={() => handleViewDetail(so)}>
                            <div className="bg-white rounded-lg overflow-hidden transition-transform hover:scale-105" style={{ cursor: "pointer", border:"1px solid #d9d9d9" }}>
                                {/* Teacher Image */}
                                <div className="relative group">
                                    <img
                                        src={so.image[0]}
                                        alt={so.title}
                                        className="w-full h-64 object-cover"
                                    />
                                </div>

                                {/* Teacher Info */}
                                <div className="" style={{paddingLeft:"1rem", paddingTop:"0.5rem"}}>
                                    <h6 className='labelHeader18600'>{so.title}</h6>
                                    {/* <h6 className='labelHeader18700'>$ {so.salePrice}</h6> */}
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </Carousel>
        </div>
    );
};

export default RelatedProducts;

